// import StarRating from '@common/components/Rating/StarRating';
// import { ReactComponent as ShipIcon } from '@common/icons/ShipIcon.svg';
// import ProductAddToCartHOC from '@common/components/ProductAddToCartHOC';
import ProductAddToCartHOC from '@common/components/ProductAddToCartHOC';
import Product from '@common/models/Product';
// import { PRODUCT_TYPE } from '@common/models/Product';
import { RootState } from '@common/store';
import { addProductToCart } from '@common/store/cart/slice';
import { addToast, removeToast, ToastWithKeyType } from '@common/store/toasts/slice';
import Gallery from '@components/Gallery';
import ProductAddToCart from '@components/ProductAddToCart';
// import Share from '@components/Share';
// import Close from '@images/Close.svg';
// import Editor from '@lib/Editor';
import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';

export interface designProps {
  productCardWidth?: string;
  innerProductCardWidth?: string;
  toasts: ToastWithKeyType[];
}

export interface ProductProps {
  addToast: typeof addToast;
  removeToast: typeof removeToast;
  type?: string;
  isZoomEnabled?: boolean;
  quickView?: boolean;
  product: Product;
  cartProductQuantity: number;
  addProductToCart: typeof addProductToCart;
  storeType: string;
  toasts: ToastWithKeyType[];
  design?: designProps;
  onClose?: () => void;
  review: number;
  scrollToReview?: () => void;
  wishListFeature: boolean;
  finalProduct: Product;
  hocArgs: unknown;
  productVideoFeature: boolean;
  reviewsCount: number;
}

const ProductComponent: React.FunctionComponent<ProductProps> = ({
  isZoomEnabled = false,
  quickView,
  product,
  cartProductQuantity,
  addToast,
  addProductToCart,
  storeType,
  scrollToReview,
  toasts,
  // toasts,
  // removeToast,
  // onClose,
  review,
  wishListFeature,

  productVideoFeature,
  reviewsCount,
}) => {
  return (
    <ProductAddToCartHOC
      variantSetToMinQuantity={true}
      disableSuccessToasts={() => false}
      product={product}
      render={(hocArgs) => {
        const { finalProduct } = hocArgs;
        return (
          <div className="w-full pt-20">
            <div className={classnames(`bg-white rounded-md `)}>
              <div className="flex flex-wrap md:flex-no-wrap">
                <div className={classnames('w-full md:w-fit')}>
                  <Gallery
                    isZoomEnabled={isZoomEnabled}
                    images={finalProduct.images.length ? finalProduct.images : product.images}
                    inStock={finalProduct.inStock}
                    quickView={quickView}
                    imageDescription={`${finalProduct.images.length ? finalProduct.title : product.title}${
                      finalProduct?.optionValues?.length ? '_' + finalProduct?.optionValues.join('_') : ''
                    }`}
                    productVideoUrl={finalProduct.productVideoUrl}
                    productVideoEnabled={productVideoFeature ? finalProduct.productVideoEnabled : false}
                  />
                </div>
                <div className={`flex flex-col md:ml-30 mt-24 md:mt-0 w-full md:w-fit xl:w-470`}>
                  {/* {quickView && (
                    <div className="w-full hidden md:block relative">
                      <img
                        src={Close}
                        alt="Close"
                        className="absolute right-0 m-16 cursor-pointer h-16 w-16"
                        onClick={() => {
                          onClose();
                          toasts.length ? toasts.map((t) => removeToast(t.key)) : null;
                        }}
                      />
                      <br />
                      <br />
                    </div>
                  )} */}
                  <h1
                    className={classnames(
                      'flex text-26 md:text-46 leading-31 md:leading-55  font-extrabold text-title content-start',
                    )}
                    font-customisation="section-heading"
                    color-customisation="page-heading"
                    id="product-title"
                  >
                    {finalProduct.title}
                  </h1>

                  <ProductAddToCart
                    reviewsCount={reviewsCount}
                    product={product}
                    addToast={addToast}
                    cartProductQuantity={cartProductQuantity}
                    addProductToCart={addProductToCart}
                    hocArgs={hocArgs}
                    storeType={storeType}
                    quickView={quickView}
                    review={review}
                    toasts={toasts}
                    scrollToReview={scrollToReview}
                    wishListFeature={wishListFeature}
                    productVideoEnabled={productVideoFeature ? finalProduct.productVideoEnabled : false}
                  />
                </div>
              </div>
              {/* {finalProduct.shortDescription && !quickView ? (
          <div className="w-full">
            <div className="text-black text-20 mb-16 tracking-wide font-bold">Overview</div>
            <Editor name="productShortDescription" value={finalProduct.shortDescription} readonly={true} />
          </div>
        ) : null} */}
            </div>
            {/* {finalProduct.description && !quickView ? (
        <div className="bg-white mt-46 md:mt-64">
          <div className="text-black text-18 md:text-20 mb-16 font-bold">Description</div>
          <Editor name="productLongDescription" value={finalProduct.description} readonly={true} />
        </div>
      ) : null} */}
          </div>
        );
      }}
    />
  );
};

export default connect(
  ({ toasts }: RootState) => ({
    toasts,
  }),
  {
    removeToast,
  },
)(ProductComponent);
